/**
 * Die Szene dieser App fuer das GlyphField: GlyphLoader (erster
 * Ladebildschirm), GlyphErrorPage (404) und `ErrorBoundary appKey` (500).
 * ui-react traegt die Engine NICHT mit; das Modul unten registriert
 * `<wt-glyphfield>` einmal (Nebeneffekt-Import, ≈ 32 KB, nur
 * `neuralWhale:login`). Solange es nicht geladen ist, bleibt jedes Feld ein
 * leerer Rahmen — der Text der Bausteine steht trotzdem.
 *
 * **Warum nicht als statischer Import in main.tsx:** dieselbe Lehre wie in
 * accountingFox (d36c0af2, PR 790) und designButterfly. Die Engine zeichnet
 * mit bis zu 30 Bildern je Sekunde auf dem Hauptthread. Laeuft sie schon,
 * bevor die App steht, muss sich der Aufbau der Huelle zwischen die Bilder
 * draengen; auf einem ausgelasteten Rechner kamen Kopfzeile und Launcher dort
 * erst nach 6,4 s statt 4,5 s.
 *
 * **Darum:** App.tsx stoesst das Laden erst an, wenn sie selbst eingehaengt
 * ist (Effekt beim Einhaengen), und auch dann erst im Leerlauf des Browsers
 * (`requestIdleCallback`). Die Szene ist damit ein eigener Chunk, nicht Teil
 * des Einstiegs.
 *
 * Exakt 4.2.1: 4.2.0 erklaerte im design-system nur `*.css` als Nebeneffekt,
 * und der Produktionsbau warf den Szenen-Import weg (leeres Feld).
 */

/** Fuehrt eine Aufgabe spaeter aus — im Test austauschbar. */
export type Planer = (aufgabe: () => void) => void;

/** Im Leerlauf des Browsers; Safari kennt `requestIdleCallback` nicht. */
export const imLeerlauf: Planer = (aufgabe) => {
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(() => aufgabe());
  } else {
    window.setTimeout(aufgabe, 0);
  }
};

let angestossen = false;

/**
 * Laedt die Szene genau einmal, im Leerlauf. Mehrfache Aufrufe sind gefahrlos
 * (StrictMode haengt Effekte doppelt ein). Scheitert das Laden — etwa ein
 * veralteter Chunk nach einem Deploy —, bleibt das Feld leer und der Text steht.
 */
export function ladeGlyphSzeneImLeerlauf(planen: Planer = imLeerlauf): void {
  if (angestossen) return;
  angestossen = true;
  planen(() => {
    import('@weretradeit/design-system/v3/glyphfield/wt-glyphfield.neuralWhale.js').catch((fehler: unknown) => {
      console.warn('GlyphField-Szene nicht geladen', fehler);
    });
  });
}
